export default "__VITE_ASSET__5xsU5M1Z__"